import { useQuery } from '@apollo/client';
import { InfoPanel } from '../index';
import { generatedTypesNew } from '@css-xp/graphtypes';
import React from 'react';
import { fetchInflightInvoice } from './queries/fetch-inflight-invoice';
import { withApollo } from '../graphql-provider';
import './inflight-invoice-banner.scss';
import { Appearance } from '@atlaskit/section-message';

export interface InflightInvoiceBannerProps {
  transactionAccountId: string;
  message: string;
  type?: Appearance;
}

export const InflightInvoiceBanner: React.FC<InflightInvoiceBannerProps> = ({
  transactionAccountId,
  message,
  type = 'warning',
}) => {
  const { data, loading } = useQuery<
    generatedTypesNew.FetchInflightInvoiceQuery,
    generatedTypesNew.FetchInflightInvoiceQueryVariables
  >(fetchInflightInvoice, {
    variables: { id: transactionAccountId },
    fetchPolicy: 'cache-and-network',
    displayName: 'fetchInflightInvoice',
    skip: !transactionAccountId,
  });

  if (loading) return null;

  return (
    <div className="inflight-invoice-banner">
      {data?.transactionAccount?.pendingInvoices && <InfoPanel type={type} message={message} />}
    </div>
  );
};

export default withApollo(InflightInvoiceBanner);
